export default "__VITE_PUBLIC_ASSET__ffc3d873__"